import {
  Component, ElementRef, OnInit, Renderer2, ViewChild,
  AfterViewInit, OnDestroy, Injector, HostListener
} from '@angular/core';
import { Observable, Subscription, interval } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';

import { SubSink } from 'subsink';

import { SubjectsService } from 'src/app/core/services/subjects.service';
import { AutenticacionStoreService } from '../../../feature/autenticacion/store/autenticacion-store.service';
import { UtilService } from '../../../core/services/util.service';
import { DetalleSucursalesService } from '../../../feature/monitoreo/services/detalle-sucursales.service';
import { SweetAlertService } from '../../../core/services/sweet-alert.service';
import { ToastService } from '../../../core/services/toast.service';

import { SessionDto } from '../../../core/data/SessionDto';
import { GenericDto } from '../../../core/data/GenericDto';
import { ConsultarMensajeDto } from '../../../feature/monitoreo/data/ConsultarMensajeDto';
import { constantes } from 'src/app/core/data/Constantes';
import { Store } from '@ngrx/store';

const numbers = interval(59000);

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
})
export class NavBarComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('hamburger', { static: false }) public hamburger: ElementRef;
  @ViewChild('menuActive', { static: false }) public menuActive: ElementRef;
  @ViewChild('sizeHeader', { static: false }) public sizeHeader: ElementRef;

  private subs = new SubSink();

  public contador?: number;
  public resize$?: Observable<number>;
  public resize?: number;
  public session$?: Observable<SessionDto>;
  public session?: SessionDto;
  public nombre?: string;
  public apellido?: string;
  public nombreCompleto?: string;
  public cantidadCorreos = 0;

  public sweetAlertService: SweetAlertService;
  public subjectService: SubjectsService;
  public utilService: UtilService;
  public rendere: Renderer2;
  public autenticacionStoreService: AutenticacionStoreService;
  public detalleSucursalesService: DetalleSucursalesService;
  public toastService: ToastService;
  public router: Router;
  public cdr: ChangeDetectorRef;
  public isMouseInLeftZone = false;
  public ocultoLogin = false;
  private subscription: Subscription;

  constructor(private readonly injector: Injector, private store: Store) {

    this.sweetAlertService = injector.get<SweetAlertService>(SweetAlertService);
    this.subjectService = injector.get<SubjectsService>(SubjectsService);
    this.utilService = injector.get<UtilService>(UtilService);
    this.rendere = injector.get<Renderer2>(Renderer2);
    this.rendere = injector.get<Renderer2>(Renderer2);
    this.detalleSucursalesService = injector.get<DetalleSucursalesService>(DetalleSucursalesService);
    this.autenticacionStoreService = injector.get<AutenticacionStoreService>(AutenticacionStoreService);
    this.toastService = injector.get<ToastService>(ToastService);
    this.router = injector.get<Router>(Router);
    this.cdr = injector.get<ChangeDetectorRef>(ChangeDetectorRef);

    this.session$ = this.autenticacionStoreService.obtenerSession$();
    this.resize$ = this.subjectService.resolucionPantalla;

    this.subscription = this.subjectService.onObtenerNombrefuncion().subscribe(() => this.obtenerSessionUsuario());
  }

  ngOnInit(): void {
    this.contador = 0;
    this.obtenerResize();
    this.obtenerSessionUsuario();
    this.consultarCantidadMensajesInterval();
    this.consultarCantidadMensajesExterno();

    this.abrirSidebar();
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    this.ocultarSidebarLogin().then(() => this.consultarCantidadMensajesSinLeer());
    this.abrirSidebar();
    this.subjectService.moveIconNavGet.subscribe(resp => {
      if(!resp){
        this.rendere.removeClass(this.menuActive.nativeElement, 'is-activeMenu');
        this.subjectService.iconSidebarSet = false;
      }else if (resp) {
        this.subjectService.iconSidebarSet = true;
        this.rendere.addClass(this.menuActive.nativeElement, 'is-activeMenu');
      }
    });
    this.cdr.detectChanges();
    this.validadorInicial();
  }

  public obtenerResize(): number {
    this.subs.add(this.resize$.subscribe((dataResize: number) => {
      this.resize = dataResize;
    }));
    return this.resize;
  }

  public obtenerSessionUsuario(): void {
    this.subs.add(this.session$.subscribe({
      next: (store: SessionDto) => {
        this.session = store;
        if(Object.keys(store).length > 2) {
          this.subjectService.hideSidebarNavbarSet = false;
          this.ocultoLogin = false;
        }else {
          this.ocultoLogin = true;
          this.subjectService.hideSidebarNavbarSet = true;
        }

        if (this.session?.apellido === undefined || this.session?.apellido === null || !this.ocultoLogin) {
          this.nombreCompleto = this.session?.nombre;
        } else {

          this.apellido = this.utilService.dividirApellido(this.session?.apellido);

          if (this.resize <= 1000) {
            if (this.session?.nombre === this.apellido) {
              this.nombreCompleto = this.session?.nombre;
            } else {
              this.nombreCompleto = this.session?.nombre + ' ' + this.apellido;
            }
          } else {
            if (this.session?.nombre === this.apellido) {
              this.nombreCompleto = this.session?.nombre;
            } else {
              this.nombreCompleto = this.session?.nombre + ' ' + this.session?.apellido;
            }
          }
        }
      }
    }));


  }

  public validadorInicial(): void {
    const stateSidebar = localStorage.getItem('stateSidebar');
    this.contador = stateSidebar === 'true' || this.obtenerResize() <= 1080 ? 1 : 0;

    if (this.contador === 0) {
      this.rendere.addClass(this.hamburger.nativeElement, 'is-active');
      this.rendere.addClass(this.menuActive.nativeElement, 'is-activeMenu');
      this.subjectService.listadoRecursosAsideData = false;
      this.contador = 0;
    }
    else if (this.contador === 1) {
      this.rendere.removeClass(this.hamburger.nativeElement, 'is-active');
      this.rendere.removeClass(this.menuActive.nativeElement, 'is-activeMenu');
      this.subjectService.listadoRecursosAsideData = true;
      this.contador = 1;
    }
  }

  public abrirSidebar(): void {
    if (this.contador === 0) {
      this.contador = 1;
      this.subjectService.listadoRecursosAsideData = true;
    }
    else if (this.contador === 1) {
      this.contador = 0;
      this.subjectService.listadoRecursosAsideData = false;
    }
    this.subjectService.listadoRecursosAside.subscribe(resp => {
      if(resp){
        this.contador = 1;
        this.rendere.removeClass(this.menuActive.nativeElement, 'is-activeMenu');
        this.rendere.removeClass(this.hamburger.nativeElement, 'is-active');
        this.subjectService.iconSidebarSet = false;
      }else {
        this.contador = 0;
        this.subjectService.iconSidebarSet = true;
        this.rendere.addClass(this.menuActive.nativeElement, 'is-activeMenu');
        this.rendere.addClass(this.hamburger.nativeElement, 'is-active');
      }
    });
  }

  public consultarCantidadMensajesSinLeer(): void {

    const consultarMensaje = new ConsultarMensajeDto();
    consultarMensaje.codigoUsuario = this.session?.codigousuario;
    consultarMensaje.session = this.session?.session;

    // COM ocultoLogin en false Para que no se muestre en el login
  if(!this.ocultoLogin) {
      this.subs.add(this.detalleSucursalesService.consultarCantidadMensajesSinLeer(consultarMensaje).subscribe({
        next: (respuesta: GenericDto) => {
          if (respuesta.status === 200) {

            this.cantidadCorreos = respuesta.payload;

            if (this.cantidadCorreos >= 1) {
              this.subjectService.habilitarBotonMarcarMensajesLeidosSet = false;
              const text = `${constantes.TOAST_NUEVO_MENSAJE} ${this.cantidadCorreos} mensaje por revisar.`;
              this.toastService.toastMensajeSinLeer(text);

            } else {
              this.subjectService.habilitarBotonMarcarMensajesLeidosSet = true;

            }
          }
          else if (respuesta.status === 500) {
            this.sweetAlertService.sweetAlertError500(respuesta.payload.message);

          }
        }, error: (err) => {

          if (err.status === 503) {
            this.sweetAlertService.sweetAlertError503();
          }
        }
      }));
    }
  }

  public cerrarSession(): void {
    this.sweetAlertService.sweetAlertCierreSesion();
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (event.clientX < 75 && this.contador === 1) {
      if (!this.isMouseInLeftZone) {
        localStorage.setItem('stateSidebar', 'true');
        this.isMouseInLeftZone = true;
        this.subjectService.listadoRecursosAsideData = false;
        this.rendere.addClass(this.menuActive.nativeElement, 'is-activeMenu');
      }
    } else if(event.clientX > 342){
      if (this.isMouseInLeftZone || localStorage.getItem('stateSidebar') === 'true') {
        localStorage.setItem('stateSidebar', 'false');
        this.isMouseInLeftZone = false;
        this.subjectService.listadoRecursosAsideData = true;
        this.rendere.removeClass(this.menuActive.nativeElement, 'is-activeMenu');
      }
    }
  }
  public consultarCantidadMensajesExterno(): void {
    this.subs.add(this.subjectService.llamarFuncionCantidadMensajesGet.subscribe((llamar: boolean) => {
      if (llamar) {
        this.consultarCantidadMensajesSinLeer();
      }
    }));
  }

  public consultarCantidadMensajesInterval(): void {
    this.subs.add(numbers.subscribe(() => {
      this.consultarCantidadMensajesSinLeer();

    }));
  }

  public redireccionarMesajeria(): void {
    this.router.navigateByUrl(constantes.REDIRECCIONARMONITOREO_MENSAJERIA);
  }

  ocultarSidebarLogin(): Promise<boolean> {
    return new Promise(res => {
      this.subjectService.ocultarSidebarLoginGet.subscribe(respuesta => respuesta ? this.ocultoLogin = true : this.ocultoLogin = false);
      this.obtenerSessionUsuario();
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
